<template>
  <qtm-content-block title="Additional Information">
    <v-row>
      <v-col cols="6">
        <qtm-input-label label="Supplier Comment">
          <qtm-textarea
            v-model="quote.comments"
            auto-grow
            placeholder="Additional information to share with the customer"
            hide-details
          />
        </qtm-input-label>
      </v-col>
      <v-col cols="6">
        <div class="qtm-label text-secondary">
          Customer's Delivery Instruction
        </div>
        <div class="qtm-body text-dark-grey">
          {{ order.comment?.length ? order.comment : '-' }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <quote-status v-model="quote.response_received" />
      </v-col>
      <v-col>
        <v-switch v-model="quote.outdated" color="interactive" hide-details label="Outdated" />
      </v-col>
    </v-row>
  </qtm-content-block>
</template>

<script setup lang="ts">
import type { Quote, Order } from '@quotetome/materials-api'
import QuoteStatus from '@/components/quotes/quote-status.vue'

defineProps<{
  quote: Quote
  order: Order
}>()
</script>
